export var ListLevelSort;
(function (ListLevelSort) {
    ListLevelSort["CUSTOM"] = "custom";
    ListLevelSort["LEVEL_ID"] = "levelId";
    ListLevelSort["NAME"] = "name";
    ListLevelSort["RATING"] = "rating";
    ListLevelSort["ENJOYMENT"] = "enjoyment";
})(ListLevelSort || (ListLevelSort = {}));
